import { render, staticRenderFns } from "./PlatformDrugs.vue?vue&type=template&id=62f55962&scoped=true"
import script from "./PlatformDrugs.vue?vue&type=script&lang=js"
export * from "./PlatformDrugs.vue?vue&type=script&lang=js"
import style0 from "./PlatformDrugs.vue?vue&type=style&index=0&id=62f55962&prod&lang=scss&scoped=true"
import style1 from "./PlatformDrugs.vue?vue&type=style&index=1&id=62f55962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f55962",
  null
  
)

export default component.exports